import React, { useContext, useEffect, useMemo, useState } from 'react'
import SrpList from '../Components/Srp/SrpList'
import { getImages } from '../Components/const';
import srpBg1 from '../assets/images/srp-bg.webp';
import srpBg2 from '../assets/images/srp-img2.png';
import srpBg3 from '../assets/images/srp-img3.png';
import { VehicleContext } from '../Components/Context/VehicleContext';
import SelectFilterModal from '../Components/Srp/SelectFilterModal';
import ModalLayout from '../Components/Common/ModalLayout';
import MoreFilterModal from '../Components/Srp/MoreFilterModal';
import { useLocation } from 'react-router-dom';
import SrpListForNew from '../Components/Srp/SrpListForNew';
import SeoMeta from '../Components/Common/SeoMeta';
const images = [srpBg1, srpBg2, srpBg3];
const Srp = ({ typeFilter, certified }) => {

    const location = useLocation();

    const { vehicleData,
        filteredVehicleData, numberFormatter,
        priceFormatter, currentFilterData,
        setCurrentFilterData,
        priceFilterData,
        mileageFilterData,
        setPriceFilterData,
        setMileageFilterData,
        conditionFilters,
        setConditionFilters,
        certifiedFilter,
        setCertifiedFilter,
        searchText,
        setSearchText
    } = useContext(VehicleContext);

    const searchInputChanged = (val) => {
        setSearchText(val);
    }
    const [bgImage, setBgImage] = useState("");

    const queryParameters = useMemo(() => new URLSearchParams(location.search), [location.search]);

    useEffect(() => {

        const vehicleMake = queryParameters.get("make");
        const vehicleModel = queryParameters.get("model");

        console.log("Route changed →", location.pathname, { typeFilter, certified }, vehicleMake, vehicleModel);

        if (vehicleMake) {

            const filter_data = currentFilterData.make.map((v, i) => {
                return v.name.toLowerCase() == vehicleMake.toLowerCase() ? { ...v, "isSelected": true } : { ...v, "isSelected": false };
            });

            setCurrentFilterData({ ...currentFilterData, ["make"]: filter_data });

        } else {
            clearFilter("make");
        }

        if (vehicleModel) {

            const filter_data = currentFilterData.model.map((v, i) => {
                return v.name.toLowerCase() == vehicleModel.toLowerCase() ? { ...v, "isSelected": true } : { ...v, "isSelected": false };
            });

            setCurrentFilterData({ ...currentFilterData, ["model"]: filter_data });

        } else {
            clearFilter("model");
        }

        if (typeFilter) {
            setConditionFilters(Array.isArray(typeFilter) ? typeFilter : [typeFilter]);
        } else {
            setConditionFilters(["new","used","recently sold"]);
        }
        setCertifiedFilter(!!certified);
        
    }, [queryParameters, vehicleData, typeFilter, certified, location.key]);

    const [filerOptionsOpen, setFilerOptionsOpen] = useState(false);
    const handleMobFilterBtn = () => {
        setFilerOptionsOpen(true)
    }
    const closeSrpFilter = () => {
        setFilerOptionsOpen(false)
    }

    // Filter Modal
    const [openFilterModal, setOpenFilterModal] = useState(false);
    const [filterData, setFilterData] = useState("");
    const [activeFilter, setActiveFilter] = useState("");
    const handleFilterModal = (field) => {
        setOpenFilterModal(true);
        setFilterData(currentFilterData[field]);
        setActiveFilter(field);
    }
    const closeMakeModal = () => {
        setOpenFilterModal(false)
    }
    const updateFilter = (filter_data) => {
        setCurrentFilterData({ ...currentFilterData, [activeFilter]: filter_data });
    }

    const clearFilter = (field, itemName) => {
        if (!currentFilterData[field]) return;
        const updatedItems = currentFilterData[field].map(v => {
            if(itemName) {
                return v.name === itemName ? { ...v, isSelected: false } : v;
            } else 
                return { ...v, isSelected: false };
        });
        setCurrentFilterData({
            ...currentFilterData,
            [field]: updatedItems
        });
    }

    useEffect(() => {
        if (conditionFilters.length == 0) setConditionFilters(["new","used","recently sold"]);
    }, [conditionFilters]);

    const clearAllFilters = () => {
        /*clearFilter('year');
        clearFilter('make');
        clearFilter('model');
        clearFilter('trim');
        clearFilter('body_style');*/

        handlePriceSliderChange([priceFilterData.min, priceFilterData.max]);
        handleMileageSliderChange([mileageFilterData.min, mileageFilterData.max]);

        const filter_data = {};

        Object.keys(currentFilterData).map((field) => {
            filter_data[field] = [];
            currentFilterData[field].forEach((v) => {
                filter_data[field].push({ ...v, isSelected: false })
            });
        });

        setCurrentFilterData(filter_data);

        setConditionFilters(["new","used","recently sold"]);

        setCertifiedFilter(false);
    }

    // More Filter Modal

    const [openMoreModal, setOpenMoreModal] = useState(false);
    const handleFilterMoreModal = () => {
        setOpenMoreModal(true);
        document.body.classList.add('body-overflow');
    }
    const closeFilterMoreModal = () => {
        setOpenMoreModal(false)
        document.body.classList.remove('body-overflow');
    }



    const handlePriceSliderChange = (newValue) => {
        setPriceFilterData({ ...priceFilterData, ['current_min']: newValue[0], ['current_max']: newValue[1] });
    };

    const handleMileageSliderChange = (newValue) => {
        setMileageFilterData({ ...mileageFilterData, ['current_min']: newValue[0], ['current_max']: newValue[1] });
    };

    // For mobile View Condition

    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * images.length);
        setBgImage(images[randomIndex]);

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            console.log("clearing filters on srp exit");
            clearAllFilters();
        };
    }, []);

    const isNewOnly = (
        conditionFilters.includes("new") &&
        !conditionFilters.includes("used") &&
        conditionFilters.length === 1
    );
    return (
        <>
            {conditionFilters.includes("used") ?
                (certified ?
                    <SeoMeta
                        title="McLaren Orlando | Certified Pre-Owned McLarens For Sale"
                        description="View photos and details of our entire Certified Pre-Owned (CPO) McLaren inventory for sale! For more information call McLaren Orlando today! (407) 988-0111"
                        keywords="McLaren, certified, CPO, pre-owned, used, 720S, 600LT, 570S, 650LT, Orlando"
                        ogTitle="McLaren Orlando | Certified Pre-Owned McLarens For Sale"
                        ogDescription="View photos and details of our entire Certified Pre-Owned (CPO) McLaren inventory for sale! For more information call McLaren Orlando today! (407) 988-0111"
                    /> :
                    <SeoMeta
                        title="McLaren Orlando | Pre-Owned McLarens For Sale"
                        description="View photos and details of our entire used McLaren inventory for sale! For more information call Mclaren Orlando today! (407) 988-0111"
                        keywords=""
                        ogTitle="McLaren Orlando | Pre-Owned McLarens For Sale"
                        ogDescription="View photos and details of our entire used McLaren inventory for sale! For more information call Mclaren Orlando today! (407) 988-0111"
                    />)
                : conditionFilters.includes("new") ?
                    <SeoMeta
                        title="McLaren Orlando | New McLaren For Sale"
                        description="Visit McLaren Orlando & discover our New McLaren Inventory. Shop McLaren 720s, McLaren 720S Spider, McLaren 600LT, McLaren 570S, & McLaren 650LT, and many other McLaren models. Speak with out top specialists & find the best McLaren for you: (407) 988-0111"
                        keywords=""
                        ogTitle="McLaren Orlando | New McLaren For Sale"
                        ogDescription="Visit McLaren Orlando & discover our New McLaren Inventory. Shop McLaren 720s, McLaren 720S Spider, McLaren 600LT, McLaren 570S, & McLaren 650LT, and many other McLaren models. Speak with out top specialists & find the best McLaren for you: (407) 988-0111"
                    />
                    :
                    <SeoMeta
                        title="McLaren Orlando | Pre-Owned McLarens For Sale"
                        description="Visit McLaren Orlando & discover our New McLaren Inventory. Shop McLaren 720s, McLaren 720S Spider, McLaren 600LT, McLaren 570S, & McLaren 650LT, and many other McLaren models. Speak with out top specialists & find the best McLaren for you: (407) 988-0111"
                        keywords=""
                        ogTitle="McLaren Orlando | Pre-Owned McLarens For Sale"
                        ogDescription="Visit McLaren Orlando & discover our New McLaren Inventory. Shop McLaren 720s, McLaren 720S Spider, McLaren 600LT, McLaren 570S, & McLaren 650LT, and many other McLaren models. Speak with out top specialists & find the best McLaren for you: (407) 988-0111"
                    />
            }
            <section className='srp-wrap'
                style={{
                    background: `#222 url(${bgImage}) no-repeat center top`,
                }}
            >
                <div className='srp-top-block'>
                    <div className='container'>
                        <div className='d-flex align-items-center justify-content-between mb-3 srpt-title'>
                            <div className='main-title text-start fw-700'>Search Results</div>
                            <div className="d-lg-none">
                                <button type="button" className="filter-btn" onClick={handleMobFilterBtn}>
                                    Filters
                                    <img alt="icon" src={getImages('filter_icon.svg')} />
                                </button>
                            </div>
                        </div>
                        <div className='d-flex align-items-center justify-content-between search-flex mb-3'>
                            <div className='d-flex search-box'>
                                <input type='text' className='form-control'
                                    placeholder='Search'
                                    value={searchText}
                                    onChange={(e) => { searchInputChanged(e.target.value) }}
                                />
                                <button className='search-btn'><span className='search-icon'></span></button>
                            </div>
                            <div className={`d-lg-inline-flex align-items-start srp-filter-block ${filerOptionsOpen ? '' : 'd-none'}`}>
                                <div className='srp-filter-header d-lg-none'>
                                    <div>Filters</div>
                                    <button className='sf-close-icon' onClick={closeSrpFilter} type='button'><img src={getImages('cross_icon.svg')} /></button>
                                </div>
                                <div className='srp-filter-body d-inline-flex gap-3'>
                                    <div className='d-lg-none mb-2'>
                                        <div className='sm-title text-start mb-1'>Applied Filters</div>
                                        <div className='d-flex align-items-center fl-tags'>
                                            <div className='fl-tag'><span>2022-2023</span> <button type='button' className='close-icon'></button></div>
                                            <div className='fl-tag'><span>1k-20k</span> <button type='button' className='close-icon'></button></div>
                                        </div>
                                    </div>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('year')}>
                                        <img src={getImages('year-icon.png')} />
                                        <span>Year</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('make')}>
                                        <img src={getImages('make-icon.png')} />
                                        <span>Make</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('model')}>
                                        <img src={getImages('model-icon.png')} />
                                        <span>Model</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('trim')}>
                                        <img src={getImages('trim-icon.png')} />
                                        <span>Trim</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={handleFilterMoreModal}>
                                        <img src={getImages('more-icon.png')} />
                                        <span>More</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='selected-block d-flex mb-1'>
                            <div className='fl-items-count md-title me-3'>{filteredVehicleData ? filteredVehicleData.length : ""} Results</div>
                            <div className='d-flex align-items-center fl-tags'>
                                {conditionFilters.map((item, index) =>
                                    <div className='fl-tag' key={index}>
                                        <span className='filter-modal-title'>{item}</span>
                                        <button type='button' className='close-icon' onClick={() => {
                                            clearFilter(item);

                                            setConditionFilters(conditionFilters.filter((condition) => condition !== item));
                                        }}></button>
                                    </div>
                                )}
                                {(priceFilterData.current_min > priceFilterData.min || priceFilterData.current_max < priceFilterData.max) &&
                                    <div className='fl-tag'>
                                        Price {priceFilterData.current_min == priceFilterData.min ? "Min" : numberFormatter(priceFilterData.current_min, true)} - {priceFilterData.current_max == priceFilterData.max ? "Max" : numberFormatter(priceFilterData.current_max, true)}
                                        <button type='button' className='close-icon' onClick={() => { handlePriceSliderChange([priceFilterData.min, priceFilterData.max]) }} />
                                    </div>}
                                {(mileageFilterData.current_min > mileageFilterData.min || mileageFilterData.current_max < mileageFilterData.max) &&
                                    <div className='fl-tag'>
                                        Mileage {mileageFilterData.current_min == mileageFilterData.min ? "Min" : numberFormatter(mileageFilterData.current_min)} - {mileageFilterData.current_max == mileageFilterData.max ? "Max" : numberFormatter(mileageFilterData.current_max)}
                                        <button type='button' className='close-icon' onClick={() => { handleMileageSliderChange([mileageFilterData.min, mileageFilterData.max]) }} />
                                    </div>}
                                {Object.keys(currentFilterData).map((key, i) => {
                                    return (
                                        currentFilterData[key].filter((item) => item.isSelected).map((item, j) => {
                                            return (
                                                <div className='fl-tag' key={i + "-" + j}>
                                                    <span>{item.name}</span>
                                                    <button type='button' className='close-icon'
                                                        onClick={() => clearFilter(key, item.name)}
                                                    />
                                                </div>
                                            );
                                        })
                                    )
                                })}
                                {certifiedFilter && <div className='fl-tag'>
                                    <span className='filter-modal-title'>Certified</span>
                                    <button type='button' className='close-icon' onClick={() => {
                                        setCertifiedFilter(false);
                                    }}></button>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                {/*isNewOnly && filteredVehicleData ?
                    <SrpListForNew
                        filteredVehicleData={filteredVehicleData}
                        numberFormatter={numberFormatter}
                        priceFormatter={priceFormatter}
                    />
                    :
                    (filteredVehicleData && <SrpList
                        filteredVehicleData={filteredVehicleData}
                        numberFormatter={numberFormatter}
                        priceFormatter={priceFormatter}
                    />)*/
                }
                {
                   filteredVehicleData && <SrpList
                        filteredVehicleData={filteredVehicleData}
                        numberFormatter={numberFormatter}
                        priceFormatter={priceFormatter}
                    /> 
                }
            </section>
            {openFilterModal &&
                <ModalLayout open={openFilterModal} close={closeMakeModal} darkThemeCls='true' modalWidth={970}>
                    <SelectFilterModal close={closeMakeModal} filterData={filterData} updateFilter={updateFilter} activeFilter={activeFilter} />
                </ModalLayout>
            }
            {openMoreModal &&
                <ModalLayout open={openMoreModal} close={closeFilterMoreModal} darkThemeCls='true' modalWidth={970}>
                    <MoreFilterModal
                        close={closeFilterMoreModal}
                        filterData={filterData}
                        setCurrentFilterData={setCurrentFilterData}
                        numberFormatter={numberFormatter}
                        handlePriceSliderChange={handlePriceSliderChange}
                        handleMileageSliderChange={handleMileageSliderChange}
                        priceFilterData={priceFilterData}
                        mileageFilterData={mileageFilterData}
                        isMobile={isMobile}
                        handleFilterModal={handleFilterModal}
                        filteredVehicleData={filteredVehicleData}
                        currentFilterData={currentFilterData}
                        clearAllFilters={clearAllFilters}
                        conditionFilters={conditionFilters}
                        setConditionFilters={setConditionFilters}
                        clearFilter={clearFilter}
                    />
                </ModalLayout>
            }
        </>
    )
}

export default Srp